// src/config.js
const config = {
  apiBaseUrl:
    process.env.REACT_APP_API_BASE_URL || "https://binary-education.com",
};

export default config;
